import { StyleSheet, Text, View } from 'react-native';

import type { Tier } from 'pages/loyalty/loyalty-profile/profile-card/components/hooks/use-progress-calculation';
import { primitive } from 'styles/constants';

type ProgressMarkersProps = {
  tiers: Tier[];
  currentPoints: number;
};

export const markerWidth = 6;

export const ProgressMarkers = ({ tiers, currentPoints }: ProgressMarkersProps) => {
  const markerNodes = tiers.map((tier, index) => {
    const completed = tier.points <= currentPoints;
    const n = tiers.length;
    const markerPosition = n <= 1 ? 0 : (index / (n - 1)) * 100;

    return (
      <View key={tier.points} style={[styles.progressMarker, { left: `${markerPosition}%` }]}>
        <View style={[styles.bullet, { opacity: completed ? 1 : 0.5 }]} />
        <Text style={styles.markerLabel}>{tier.label}</Text>
      </View>
    );
  });

  return (
    <View style={styles.progressMarkers} pointerEvents="none">
      {markerNodes}
    </View>
  );
};

const styles = StyleSheet.create({
  progressMarkers: {
    position: 'absolute',
    width: '100%',
    top: 0,
    left: -markerWidth / 2,
    right: markerWidth / 2,
    bottom: 0,
  },
  progressMarker: {
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
    width: markerWidth,
    top: 0,
    bottom: 0,
  },
  bullet: {
    backgroundColor: primitive.$white,
    height: markerWidth,
    width: markerWidth,
    borderRadius: markerWidth,
  },
  markerLabel: {
    position: 'absolute',
    top: -20,
    minWidth: 40,
    fontSize: primitive.fontSizes.xs,
    fontFamily: primitive.fontFamily.$body,
    color: primitive.$bbqBrown,
    textAlign: 'center',
  },
});
